const app = {
  state: {
    device: ''
  }
}
export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js